import React from 'react';
import { useTranslation } from 'react-i18next';

import { General } from 'icons/untitledui';
import * as DropdownStyled from 'theme/components/Dropdown.style';
import * as SelectionStyled from 'theme/components/SelectionDropdown.style';
import * as Styled from '../../styles/FilterGroupingControl.style';
import { Visibility } from './_types';

interface VisibilityFilterMenuProps {
  selected: Visibility | null;
  onSelect: (value: Visibility | null) => void;
  topOffset?: number;
}

const OPTIONS: Visibility[] = ['private', 'shared'];

export default function VisibilityFilterMenu({
  selected,
  onSelect,
  topOffset,
}: VisibilityFilterMenuProps): JSX.Element {
  const { t } = useTranslation('pageEvents');

  return (
    <Styled.PopoverCard $zIndex={1400} $topOffset={topOffset} $leftOffset={-40}>
      <Styled.List>
        <DropdownStyled.SectionHeader>
          {t('filterGrouping.visibility.title')}
        </DropdownStyled.SectionHeader>
        {OPTIONS.map((visibility) => {
          const isSelected = selected === visibility;
          const Icon = visibility === 'private' ? General.EyeOff : General.Eye;
          return (
            <SelectionStyled.Option
              key={visibility}
              type="button"
              $selected={isSelected}
              onClick={() => onSelect(isSelected ? null : visibility)}
              role="menuitemradio"
              aria-checked={isSelected}
            >
              <Styled.LeadingRow>
                <DropdownStyled.ItemLeadingIcon>
                  <Icon size={20} />
                </DropdownStyled.ItemLeadingIcon>
                <span>
                  {t(`filterGrouping.visibility.options.${visibility}`)}
                </span>
              </Styled.LeadingRow>
              <SelectionStyled.OptionCheck $selected={isSelected}>
                {isSelected && <General.Check size={16} />}
              </SelectionStyled.OptionCheck>
            </SelectionStyled.Option>
          );
        })}
      </Styled.List>
    </Styled.PopoverCard>
  );
}
